const variants = {
  "main-nav": {
    button: {
      fontFamily: "Libre Franklin, sans-serif",
      fontWeight: "700",
      fontSize: "22px",
      letterSpacing: "0px",
      m: "0",
      p: "4px 0",
      color: "white",
      borderRadius: "0",
      textTransform: "none",
      backgroundColor: "transparent !important",
      borderColor: "transparent !important",
      borderTopWidth: "0px !important",
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
      _hover: {
        borderColor: "#FFF !important",
        borderStyle: "solid !important",
        backgroundColor: "transparent !important",
      },
      _focus: {
        outline: "none !important",
        borderColor: "#FFF !important",
        borderStyle: "solid !important"
      },
      _focusVisible:{
        boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)",
      }
    },
    list: {
      minWidth: "unset",
      backgroundColor: "transparent !important",
      border: "none",
    },
    item: {
      fontFamily: "Libre Franklin, sans-serif",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "0px",
      m: "0",
      color: "white",
      padding: "16px 8px",
      borderRadius: "0",
      textTransform: "none",
      background: "unset !important",
      border: "none !important",
      borderBottomWidth: "0px !important",
      borderTopWidth: "0px !important",
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
      _hover: {
        backgroundColor: "white !important",
        color: "black !important"
      },
      _focus: {
        outline: "none !important",
        backgroundColor: "white !important",
        color: "black !important"
      },
      _visited: {
        color: "white",
      }
    }
  },
  "sub-nav": {
    button: {
      fontFamily: "Libre Franklin, sans-serif",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "0px",
      m: "0",
      color: "white",
      padding: "16px 8px",
      borderRadius: "0",
      textTransform: "none",
      background: "unset !important",
      border: "none !important",
      borderBottomWidth: "0px !important",
      borderTopWidth: "0px !important",
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
      _hover: {
        backgroundColor: "white !important",
        color: "black !important"
      },
      _focus: {
        outline: "none !important",
        backgroundColor: "white !important",
        color: "black !important"
      }
    },
    list: {
      minWidth: "unset",
      backgroundColor: "transparent !important",
      border: "none",
      padding: "0",
    },
    item: {
      fontFamily: "Libre Franklin, sans-serif",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "0px",
      w: "100%",
      m: "0 !important",
      padding: "16px 8px !important",
      color: "white !important",
      borderRadius: "0",
      textTransform: "none",
      backgroundColor: "transparent !important",
      border: "none !important",
      borderBottomWidth: "0px !important",
      borderTopWidth: "0px !important",
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
      _hover: {
        backgroundColor: "white !important",
        color: "black !important"
      },
      _focus: {
        outline: "none !important",
        backgroundColor: "white !important",
        color: "black !important"
      },
      _visited: {
        color: "white",
      }
    }
  }
}

export const Menu = {
  variants,
}
